import React, {useState} from 'react';
import { LoadingSvg } from './SvgIcons';
import { readAudioFile } from './utils/audioUtils';
import { formatDate, formatDuration } from './utils/dateUtils';

const languages = ['PL', 'RU', 'ZH'];

const AddInterpretation = ({accessToken, getVideo, addInterpretation}) => {
    const [videoUrl, setVideoUrl] = useState('');
    const [video, setVideo] = useState();
    const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
    const [fileInfo, setFileInfo] = useState();
    const [addingInterpretation, setAddingInterpretation] = useState(false);
    const [audioError, setAudioError] = useState('');

    const handleFileChange = (event) => {
        if(event.target.files.length) {
            readAudioFile(event, (upload, filename, trackLengthSecs) => {
                if(upload && upload.target.result) {
                    const file = upload.target.result.split(',')[1];
                    setFileInfo({ File: file, Filename: filename, Length: trackLengthSecs });
                    setAudioError(null);
                }
            }, (error) => {
                setAudioError(error);
            }, 100);
        }
    }
    
    const getYouTubeID = (url) => {
        const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
        const match = url.match(regExp);
        return match[1];
    }

    const handleAddClick = async() => {
        if(video) {
            try {
                setAddingInterpretation(true);
                const succeeded = await addInterpretation(accessToken, video.ID, video.Title, video.PublishedDate, selectedLanguage, fileInfo.Filename, fileInfo.File);
                if(succeeded) {
                    alert('The interpretation has been uploaded successfully');
                }
            }
            catch(error) {
                alert('Sorry, something went wrong');
            }
            finally {
                setAddingInterpretation(false);
            }
        }
    }

    const findVideo = async () => {
        const videoID = getYouTubeID(videoUrl);
        if(videoID) {
            const video = await getVideo(accessToken, videoID);
            console.log(video);
            setVideo(video);
        }
    }

    return <div style={{border: 'solid 1px #aaa', maxWidth: '550px', padding: '5px', marginBottom: '10px'}}>
        <div className="row" style={{margin: '8px 0'}}>
            <label style={{marginRight: '5px'}}>Video Url:</label>
            <input type="text" style={{width: '400px'}} value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)}></input>
            <button onClick={findVideo} disabled={!videoUrl}>Find</button>
        </div>
        {video && <div style={{border: 'solid 1px #aaa', backgroundColor: '#eee', padding: '5px'}}>
            <div style={{textAlign: 'left'}}>Video title: {video.Title}</div> 
            <div style={{textAlign: 'left'}}>Published: {formatDate(video.PublishedDate)}</div>
            <div style={{textAlign: 'left', fontWeight: 500}}>Duration: {formatDuration(video.Duration)}</div>   
        </div>}
        <div className="row" style={{margin: '8px 0'}}>
            <label style={{marginRight: '5px'}}>Language:</label>
            <select value={selectedLanguage} onChange={(e) => setSelectedLanguage(e.target.value)}>
                {
                    languages.map(language => <option key={language}>{language}</option>)
                }
            </select>
        </div>
        <div className="row" style={{margin: '8px 0'}}>
            <label style={{marginRight: '5px'}}>Audio File:</label>
            <input type="file" style={{width: '400px'}} accept="audio/mp3" onChange={handleFileChange} />                                   
        </div>
        <div className="row" style={{margin: '8px 0', textAlign: 'left', fontSize: '14px'}}>
            <label>Audio files must be mp3 files. If you have another file extension, you can convert it at <a href="https://cloudconvert.com/" target="_blank">CloudConvert</a></label>
        </div>
        {fileInfo && <div style={{textAlign: 'left', fontWeight: 500}}>
            Audio duration: {formatDuration(fileInfo.Length)}
        </div>}
        {
            audioError && <div style={{color: 'red'}}>{audioError}</div>
        }
        <button style={{margin: '15px 0'}} onClick={handleAddClick} disabled={!fileInfo || !selectedLanguage || !video || addingInterpretation}>Add Interpretation</button>
        {
            addingInterpretation && <div style={{marginLeft: '10px'}}>Uploading audio... <LoadingSvg style={{verticalAlign: 'middle'}} size="40px" /></div>
        }
</div>
}

export default AddInterpretation;